export default i => /anon\+[0-9a-f-]+@ellacard.com/.test(i) ? 'Anonymous' : i;
